import {
	Component,
	HostBinding,
	OnInit,
	HostListener,
	ViewContainerRef, Inject
} from "@angular/core";
import { Title } from "@angular/platform-browser";
declare var $: any;
import { GlobalState } from "./app.state";
import { ConfigService } from "./shared/services/config/config.service";
import { PreloaderService } from "./shared/services/preloader/preloader.service";
import { SpinnerService } from "./shared/services/spinner/spinner.service";
import { ThemesService } from "./shared/services/themes/themes.service";
import { Router, NavigationEnd } from '@angular/router';
import { OrderService } from './shared/services/httpservice/order.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
	selector: "app-root",
	template: "<router-outlet></router-outlet>",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
	//App Left Sidebar Menu Open/Close Desktop
	@HostBinding("class.app_sidebar-menu-collapsed")
	get isApp_SidebarLeftCollapsed() {
		return this.config.appLayout.isApp_SidebarLeftCollapsed;
	}
	//Left Menu Sidebar Open/Close Tablet & Mobile
	@HostBinding("class.app_sidebar-left-open")
	get isApp_MobileSidebarLeftOpen() {
		return this.config.appLayout.isApp_MobileSidebarLeftOpen;
	}
	//App Right Sidebar Open/Close
	@HostBinding("class.sidebar-overlay-open")
	get isApp_SidebarRightOpen() {
		return this.config.appLayout.isApp_SidebarRightOpen;
	}
	sellerId: any;
	rows: any;
	private user: Observable<firebase.User>;

	//The constructor is called first time before the ngOnInit()
	//The constructor should only be used to initialize class members but shouldn't do actual "work".
	//So you should use constructor() to setup Dependency Injection and not much else.
	constructor(
		private _state: GlobalState,
		public config: ConfigService,
		private viewContainerRef: ViewContainerRef,
		private _spinner: SpinnerService,
		private titleService: Title,
		private themesService: ThemesService,
		private router: Router,
		private orderService: OrderService,
		private _firebaseAuth: AngularFireAuth,
		private dialog: MatDialog
	) {
		this.user = _firebaseAuth.authState;
	}
	public setTitle(newTitle: string) {
		this.titleService.setTitle(newTitle);
	}
	//called after the constructor and called  after the first ngOnChanges()
	//ngOnInit() is better place to "start" - it's where/when components' bindings are resolved.
	ngOnInit() {
		$(document).on("click", '[href="#"]', e => e.preventDefault());
		this.router.events.subscribe((evt) => {
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			$("body,html").scrollTop(0, 0);
		});

		this.user.subscribe(
			(user) => {
				if (user) {
					this.sellerId = user.uid;
					this.checkPendingWeightDisc();
				}
			});

	}
	//check if menu should reset on resize
	@HostListener("window:resize")
	public onWindowResize(): void {
		if (this._shouldMenuReset()) {
			this.config.appLayout.isApp_SidebarLeftCollapsed = false;
		}
	}

	private _shouldMenuReset(): boolean {
		return window.innerWidth <= this.config.breakpoint.desktopLG;
	}

	public ngAfterViewInit(): void {
		PreloaderService.load().then(values => {
			this._spinner.hide();
		});
	}

	checkPendingWeightDisc() {
		this.orderService.getWeightDiscrepencyRTOBySeller(this.sellerId).then(res => {
			if (res['status'] == 'SUCCESS') {
				this.rows = res['data'];
				// console.log('Disc:', this.rows);
				let msg = '';
				let heading = '';

				if (res['data'][0].length != 0 || res['data'][1].length != 0) {
					if (res['data'][0].length != 0 && res['data'][1].length != 0) {
						heading = 'Charges for Exc Weight & RTO';
					}
					else if (res['data'][0].length != 0 && res['data'][1].length == 0) {
						heading = 'Charges for Excess Weight';
					}
					else {
						heading = 'Charges for RTO';
					}
					res['data'][0].forEach(w => {
						msg = msg + '<table style="width:100%">' +
							'<tr><th>Category:</th><td>' + 'WEIGHT_DISPUTE' + '</td></tr>' +
							'<tr><th>AWB:</th><td>' + w.Awb_Number + '</td></tr>' +
							'<tr><th>Given Wt:</th><td>' + w.applied_weight + ' KG</td></tr>' +
							'<tr><th>Actual Wt:</th><td>' + w.charged_weight + ' KG</td></tr>' +
							'<tr><th>Excess Charge:</th><td>RS.' + w.adjustmet_amount + '</td></tr><br><br>' +
							'</table>';
					});
					res['data'][1].forEach(w => {
						msg = msg + '<table style="width:100%">' +
							'<tr><th>Category:</th><td>' + 'RTO_CHARGE' + '</td></tr>' +
							'<tr><th>AWB:</th><td>' + w.Awb_Number + '</td></tr>' +
							'<tr><th>Excess Charge:</th><td>RS.' + w.Mygb_Rto_Chrg + '</td></tr><br><br>' +
							'</table>';
					});
					//   this.alertMsgProcessDisputedWeight(heading, msg, this.rows, this.sellerId);
					this.processDisputedWeight(msg, this.rows, this.sellerId);
				}

				/// test
				// msg = msg + '<table style="width:100%">' +
				// 			'<tr><th>Category:</th><td>' + 'WEIGHT_DISPUTE' + '</td></tr>' +
				// 			'<tr><th>AWB:</th><td>' + 3243243 + '</td></tr>' +
				// 			'<tr><th>Given Wt:</th><td>' + 22 + ' KG</td></tr>' +
				// 			'<tr><th>Actual Wt:</th><td>' + 33 + ' KG</td></tr>' +
				// 			'<tr><th>Excess Charge:</th><td>RS.' + 2523 + '</td></tr><br><br>' +
				// 			'</table>';

				// msg = msg + '<table style="width:100%">' +
				// 			'<tr><th>Category:</th><td>' + 'RTO_CHARGE' + '</td></tr>' +
				// 			'<tr><th>AWB:</th><td>' + 25235 + '</td></tr>' +
				// 			'<tr><th>Excess Charge:</th><td>RS.' +235 + '</td></tr><br><br>' +
				// 			'</table>';
				// this.processDisputedWeight(msg, this.rows, this.sellerId);

			}
		});
	}

	processDisputedWeight(msg, rows, sellerId) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = true;
		dialogConfig.autoFocus = true;
		let body ={
			msg, rows, sellerId
		}
		dialogConfig.data = { body };
		this.dialog.open(weightDisputeComponent, dialogConfig);
	}
}

@Component({
    selector: 'weight-dispute',
    templateUrl: './weight-dispute-message.component.html',
})
export class weightDisputeComponent {
    error: string;
    steps: any;
    sellerId: any
    rows = [];

	getBodyData: any;
	msg: any;
	disputedRows: any;

    constructor(private createOrder: OrderService, private router: Router, private orderService: OrderService,
        public dialogRef: MatDialogRef<weightDisputeComponent>, @Inject(MAT_DIALOG_DATA) data) {
        // console.log("Response", data)
		this.getBodyData = data.body;
		if(data.body && data.body.msg){
			this.msg = data.body.msg
		}
		if(data.body && data.body.sellerId){
			this.sellerId = data.body.sellerId;
		}
		if(data.body && data.body.rows){
			this.disputedRows = data.body.rows;
		}

    }
    ngOnInit() {
    }
    finish() {
        this.dialogRef.close();
    }
    onNoClick(): void {
        this.dialogRef.close();
	}
	
	proceed(){
		if(this.sellerId && this.disputedRows){
		this.orderService.updateWeightDiscrepencyRTOPayment(this.sellerId, this.disputedRows).then(res => {
			// console.log('Response..', res['data']);
			this.dialogRef.close();
			alert('THNAK YOU'+ res['data']);
		  });
		}else{
			alert("please try again later");
		}
	}

}

